export const Discount = [
  { value: "percentage", label: "Percentage" },
  { value: "cash", label: "Cash" },
];

export const EditStatusOption = [
  { value: "Completed", label: "Completed" },
  { value: "Shipped", label: "Shipped" },
  { value: "Out of Delivery", label: "Out of Delivery" },
  { value: "Delivered", label: "Delivered" },
  { value: "Cancelled", label: "Cancelled" },
];
